// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { UIModelBaseElement } from './UIModelBaseElement';
import { EnumPageType } from '../../../../../com/MetaPattern/MDA/MD/UIModel/EnumPageType';
import { UIPageGroup } from './UIPageGroup';
import { PageView } from './PageView';
import { UIButton } from './UIButton';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 页面 实体类
 * 页面模型，对应于一个前端页面
 */
export class UIPage extends UIModelBaseElement {
  /** 页面类型 : 页面类型 */
  private _pageType: EnumPageType;

  /** 设置：页面类型 */
  public get pageType() {
    return this._pageType;
  }

  /** 获取：页面类型 */
  public set pageType(value: EnumPageType) {
    this._pageType = value;
  }

  /** 页面标题 : 页面标题，页面内用H1标识 */
  private _title: string;

  /** 设置：页面标题 */
  public get title() {
    return this._title;
  }

  /** 获取：页面标题 */
  public set title(value: string) {
    this._title = value;
  }

  /** 是否需登录 : 是否需登录，true代表只能登录后才能访问 */
  private _needLogin: boolean;

  /** 设置：是否需登录 */
  public get needLogin() {
    return this._needLogin;
  }

  /** 获取：是否需登录 */
  public set needLogin(value: boolean) {
    this._needLogin = value;
  }

  /** 文件名 : 页面的文件名称，用于页面路由，不需要包含路径 */
  private _filename: string;

  /** 设置：文件名 */
  public get filename() {
    return this._filename;
  }

  /** 获取：文件名 */
  public set filename(value: string) {
    this._filename = value;
  }

  /** 绑定标志 : 绑定元素的标志，使用设计期ID，用于区分自动生成情况下的来源 */
  private _bindingCode: string;

  /** 设置：绑定标志 */
  public get bindingCode() {
    return this._bindingCode;
  }

  /** 获取：绑定标志 */
  public set bindingCode(value: string) {
    this._bindingCode = value;
  }

  /** 页面分组 的ID */
  private _pageGroup_ID: string;

  /** 获取：页面分组 的ID */
  public get pageGroup_ID() {
    return this._pageGroup_ID;
  }

  /** 设置：页面分组 的ID */
  public set pageGroup_ID(value: string) {
    this._pageGroup_ID = value;
  }

  /** 页面分组  */
  private _pageGroup: UIPageGroup;

  /** 获取：页面分组  */
  public get pageGroup() {
    return this._pageGroup;
  }

  /** 设置：页面分组  */
  public set pageGroup(value: UIPageGroup) {
    this._pageGroup = value;
    if (value !== null) {
      this.pageGroup_ID = value.id;
    } else {
      this.pageGroup_ID = '';
    }
  }

  /** 页面视图 */
  private _pageViews: Array<PageView>;

  /** 获取：页面视图 */
  public get pageViews() {
    return this._pageViews;
  }

  /** 设置：页面视图 */
  public set pageViews(value: Array<PageView>) {
    this._pageViews = value;
  }

  /** 按钮 */
  private _buttons: Array<UIButton>;

  /** 获取：按钮 */
  public get buttons() {
    return this._buttons;
  }

  /** 设置：按钮 */
  public set buttons(value: Array<UIButton>) {
    this._buttons = value;
  }

  constructor() {
    super();
    this._pageType = EnumPageType.Entity;
    this._title = '';
    this._needLogin = true;
    this._filename = '';
    this._bindingCode = '';
    this._pageGroup_ID = '';
    this._pageGroup = null;
    this._pageViews = new Array<PageView>();
    this._buttons = new Array<UIButton>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: UIPage, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.pageType = element.pageType;
      this.title = element.title;
      this.needLogin = element.needLogin;
      this.filename = element.filename;
      this.bindingCode = element.bindingCode;
      this.pageGroup_ID = element.pageGroup_ID;
      if (hasReference && element.pageGroup !== null) {
        this.pageGroup = element.pageGroup;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.pageType = json.PageType as EnumPageType;
    this.title = json.Title;
    this.needLogin = json.NeedLogin;
    this.filename = json.Filename;
    this.bindingCode = json.BindingCode;
    this.pageGroup_ID = json.PageGroup_ID;
    // if (json.PageGroup !== null) {
    //   this.pageGroup = UIPageGroup.Create(json.PageGroup);
    // }
    if (json.PageViews && json.PageViews.length > 0) {
      json.PageViews.forEach((element: any) => {
        const pageView = PageView.Create(element);
        // pageView.page = this;
        this.pageViews.push(pageView);
      });
    }
    if (json.Buttons && json.Buttons.length > 0) {
      json.Buttons.forEach((element: any) => {
        const uIButton = UIButton.Create(element);
        // uIButton.page = this;
        this.buttons.push(uIButton);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.PageType = this.pageType;
    json.Title = this.title;
    json.NeedLogin = this.needLogin;
    json.Filename = this.filename;
    json.BindingCode = this.bindingCode;
    json.PageGroup_ID = this.pageGroup_ID;
    if (this.pageViews && this.pageViews.length > 0) {
      json.PageViews = [];
      this.pageViews.forEach((element) => {
        json.PageViews.push(element.toJson());
      });
    }
    if (this.buttons && this.buttons.length > 0) {
      json.Buttons = [];
      this.buttons.forEach((element) => {
        json.Buttons.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'pageType', '页面类型', EnumDataType.Reference, this.pageType, false, '页面类型', 'EnumPageType', 'PGRowEnumValue');
    context.addRow('基本属性', 'title', '页面标题', EnumDataType.String, this.title, true, '页面标题，页面内用H1标识', '', '');
    context.addRow('基本属性', 'needLogin', '是否需登录', EnumDataType.Bool, this.needLogin, true, '是否需登录，true代表只能登录后才能访问', '', '');
    context.addRow('基本属性', 'filename', '文件名', EnumDataType.String, this.filename, false, '页面的文件名称，用于页面路由，不需要包含路径', '', '');
    return context;
  }

  static Create(json: any): UIPage {
    const uIPage = new UIPage();
    uIPage.Deserialize(json);
    uIPage.json = json;
    return uIPage;
  }
}
